import Vue from "vue"

Vue.filter("exemple", function()
{
  return 'yo'
})
